import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Medicine({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Medicine</title>
      <rect
        x="4"
        y="4"
        width="12"
        height="3"
        rx="1"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 20.75C16.4142 20.75 16.75 20.4142 16.75 20C16.75 19.5858 16.4142 19.25 16 19.25V20.75ZM13.4091 7L13.9767 6.50979C13.8342 6.34482 13.6271 6.25 13.4091 6.25V7ZM6.59091 7V6.25C6.37294 6.25 6.16576 6.34482 6.02329 6.50979L6.59091 7ZM15.25 14C15.25 14.4142 15.5858 14.75 16 14.75C16.4142 14.75 16.75 14.4142 16.75 14H15.25ZM15.7568 9.71843L16.3244 9.22821L15.7568 9.71843ZM4.75 18V10.372H3.25V18H4.75ZM12.8415 7.49021L15.1892 10.2086L16.3244 9.22821L13.9767 6.50979L12.8415 7.49021ZM4.81079 10.2086L7.15853 7.49021L6.02329 6.50979L3.67556 9.22821L4.81079 10.2086ZM10 7.75H13.4091V6.25H10V7.75ZM10 6.25H6.59091V7.75H10V6.25ZM16 19.25H10V20.75H16V19.25ZM10 19.25H6V20.75H10V19.25ZM15.25 10.372V14H16.75V10.372H15.25ZM3.25 18C3.25 19.5188 4.48122 20.75 6 20.75V19.25C5.30964 19.25 4.75 18.6904 4.75 18H3.25ZM15.1892 10.2086C15.2284 10.2541 15.25 10.312 15.25 10.372H16.75C16.75 9.95205 16.599 9.54607 16.3244 9.22821L15.1892 10.2086ZM4.75 10.372C4.75 10.312 4.77158 10.2541 4.81079 10.2086L3.67556 9.22821C3.40105 9.54607 3.25 9.95205 3.25 10.372H4.75Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M8 12.25C7.58579 12.25 7.25 12.5858 7.25 13C7.25 13.4142 7.58579 13.75 8 13.75L8 12.25ZM12 13.75C12.4142 13.75 12.75 13.4142 12.75 13C12.75 12.5858 12.4142 12.25 12 12.25V13.75ZM10.75 11C10.75 10.5858 10.4142 10.25 10 10.25C9.58579 10.25 9.25 10.5858 9.25 11H10.75ZM9.25 15C9.25 15.4142 9.58579 15.75 10 15.75C10.4142 15.75 10.75 15.4142 10.75 15H9.25ZM8 13.75L10 13.75V12.25L8 12.25L8 13.75ZM10 13.75L12 13.75V12.25L10 12.25V13.75ZM9.25 11V13H10.75V11H9.25ZM9.25 13L9.25 15H10.75L10.75 13H9.25Z"
        fill={color ?? 'currentColor'}
      />
      <circle
        cx="17"
        cy="17"
        r="3"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 14.4019L15.5 19.598"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
